/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
import { Action } from "@songtradr-one/shared-common";
import { BulkDownloadReferenceFormat } from "@songtradr-one/shared-common";
import { BulkDownloadReferenceType } from "@songtradr-one/shared-common";
import { BulkDownloadStatus } from "@songtradr-one/shared-common";
import { ChannelPlatform } from "@songtradr-one/shared-common";
import { ChannelSortKey } from "@songtradr-one/shared-common";
import { ClearanceMediaPlatform } from "@songtradr-one/shared-common";
import { ClearanceMediaType } from "@songtradr-one/shared-common";
import { ClearanceSortKey } from "@songtradr-one/shared-common";
import { ClearanceStatus } from "@songtradr-one/shared-common";
import { ClientSortKey } from "@songtradr-one/shared-common";
import { CommercialLicenseSortKey } from "@songtradr-one/shared-common";
import { CommercialLicenseStatus } from "@songtradr-one/shared-common";
import { DefaultViewInDraftMode } from "@songtradr-one/shared-common";
import { DownloadType } from "@songtradr-one/shared-common";
import { DownloadsScope } from "@songtradr-one/shared-common";
import { ImportBatchStatus } from "@songtradr-one/shared-common";
import { ImportDataStatus } from "@songtradr-one/shared-common";
import { ImportFormat } from "@songtradr-one/shared-common";
import { IngestionJobStatus } from "@songtradr-one/shared-common";
import { LabAppEnvironment } from "@songtradr-one/shared-common";
import { LabAppStatus } from "@songtradr-one/shared-common";
import { LabDatastoreFieldType } from "@songtradr-one/shared-common";
import { LabDatastoreScope } from "@songtradr-one/shared-common";
import { LabsVersion } from "@songtradr-one/shared-common";
import { LibraryLicenseChannelType } from "@songtradr-one/shared-common";
import { LibraryLicenseSortKey } from "@songtradr-one/shared-common";
import { LikeItemsType } from "@songtradr-one/shared-common";
import { MsaDocumentSelection } from "@songtradr-one/shared-common";
import { MsaMonetizationPreference } from "@songtradr-one/shared-common";
import { MsaProfileStatus } from "@songtradr-one/shared-common";
import { MsaSourceType } from "@songtradr-one/shared-common";
import { NotificationStatus } from "@songtradr-one/shared-common";
import { NotificationType } from "@songtradr-one/shared-common";
import { OrgLoginMethods } from "@songtradr-one/shared-common";
import { OrgUserInviteBatchStatus } from "@songtradr-one/shared-common";
import { OrgUserInviteLookupStatus } from "@songtradr-one/shared-common";
import { OrgUserInviteSortKey } from "@songtradr-one/shared-common";
import { OrgUserInviteStatus } from "@songtradr-one/shared-common";
import { OrgUserStatus } from "@songtradr-one/shared-common";
import { OrgsSortKey } from "@songtradr-one/shared-common";
import { PayoutBatchStatus } from "@songtradr-one/shared-common";
import { PayoutBatchTask } from "@songtradr-one/shared-common";
import { PayoutCommentAction } from "@songtradr-one/shared-common";
import { PayoutEligibleSortKey } from "@songtradr-one/shared-common";
import { PayoutIssueKind } from "@songtradr-one/shared-common";
import { PayoutItemSource } from "@songtradr-one/shared-common";
import { PayoutItemStatus } from "@songtradr-one/shared-common";
import { PayoutStatus } from "@songtradr-one/shared-common";
import { PayoutTrolleyStatus } from "@songtradr-one/shared-common";
import { ReportColumnType } from "@songtradr-one/shared-common";
import { ReportParameterType } from "@songtradr-one/shared-common";
import { ResourceSortKey } from "@songtradr-one/shared-common";
import { SearchFilterName } from "@songtradr-one/shared-common";
import { SearchSortDirection } from "@songtradr-one/shared-common";
import { SearchSortKey } from "@songtradr-one/shared-common";
import { SearchType } from "@songtradr-one/shared-common";
import { SessionEvent } from "@songtradr-one/shared-common";
import { ShareResourceType } from "@songtradr-one/shared-common";
import { SignatoryStatus } from "@songtradr-one/shared-common";
import { SignatureDocumentStatus } from "@songtradr-one/shared-common";
import { SortDirection } from "@songtradr-one/shared-common";
import { StatementImportDataSortKey } from "@songtradr-one/shared-common";
import { StatementPaymentStatus } from "@songtradr-one/shared-common";
import { StatementSortKey } from "@songtradr-one/shared-common";
import { StemOutputFormat } from "@songtradr-one/shared-common";
import { StemStatus } from "@songtradr-one/shared-common";
import { TrackSortDirection } from "@songtradr-one/shared-common";
import { TrackSortKey } from "@songtradr-one/shared-common";
import { TrackType } from "@songtradr-one/shared-common";
import { UrlType } from "@songtradr-one/shared-common";
import { UserActionLogSource } from "@songtradr-one/shared-common";
import { UserPlaylistsSortDirection } from "@songtradr-one/shared-common";
import { UserPlaylistsSortKey } from "@songtradr-one/shared-common";
import { UserSubscriptionAddOnPricing } from "@songtradr-one/shared-common";
import { UserSubscriptionProvider } from "@songtradr-one/shared-common";

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: any; output: any };
  Currency: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export { Action };

export type AddClientInput = {
  /** Client contact */
  contact: Scalars["String"]["input"];
  /** Client email */
  email: Scalars["String"]["input"];
  /** Client name */
  name: Scalars["String"]["input"];
};

export { BulkDownloadReferenceFormat };

export { BulkDownloadReferenceType };

export { BulkDownloadStatus };

export type ChannelLookupInput = {
  name: Scalars["String"]["input"];
  platform: ChannelPlatform;
  url: Scalars["String"]["input"];
};

export { ChannelPlatform };

export { ChannelSortKey };

export type ChannelsSort = {
  direction: SortDirection;
  key?: InputMaybe<ChannelSortKey>;
};

export type ClearanceCreateInput = {
  /** Client ID */
  clientId: Scalars["ID"]["input"];
  /** Clearance end date */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Clearance media (channel/video) */
  media: ClearanceMediaCreateInput;
  /** Clearance Notes */
  notes?: InputMaybe<Scalars["String"]["input"]>;
  /** Clearance start date */
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Clearance status */
  status: ClearanceStatus;
};

export type ClearanceMediaCreateInput = {
  /** Media ID (channel/video id) */
  id: Scalars["String"]["input"];
  /** Media platform */
  platform: ClearanceMediaPlatform;
  /** Media type */
  type: ClearanceMediaType;
  /** Media url */
  url: Scalars["String"]["input"];
};

export { ClearanceMediaPlatform };

export { ClearanceMediaType };

export type ClearanceMediaUpdateInput = {
  /** Media ID (channel/video id) */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Media platform */
  platform: ClearanceMediaPlatform;
  /** Media type */
  type?: InputMaybe<ClearanceMediaType>;
  /** Media url */
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClearanceSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort Key */
  key?: InputMaybe<ClearanceSortKey>;
};

export { ClearanceSortKey };

export { ClearanceStatus };

export type ClearanceUpdateInput = {
  /** Clearance end date */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Clearance ID */
  id: Scalars["ID"]["input"];
  /** Clearance Notes */
  notes?: InputMaybe<Scalars["String"]["input"]>;
  /** Clearance start date */
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type ClientSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<ClientSortKey>;
};

export { ClientSortKey };

export type CommercialLicenseSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<CommercialLicenseSortKey>;
};

export { CommercialLicenseSortKey };

export { CommercialLicenseStatus };

export type ConnectChannelInput = {
  channelId: Scalars["String"]["input"];
  channelImage?: InputMaybe<Scalars["String"]["input"]>;
  channelName: Scalars["String"]["input"];
  channelTitle?: InputMaybe<Scalars["String"]["input"]>;
  handle?: InputMaybe<Scalars["String"]["input"]>;
  platform: ChannelPlatform;
  url: Scalars["String"]["input"];
};

/** Creates a draft document. All other fields are populated server-side with sensible defaults (empty content, effective today, no re-agreement, no scroll-to-accept) — the user fills them in on the edit screen. */
export type CreateLegalDocumentInput = {
  key: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type CreateLegalDocumentVariantInput = {
  name: Scalars["String"]["input"];
  orgIds: Array<Scalars["ID"]["input"]>;
  /** Org version to copy (null copies the default version) */
  sourceVariantId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateOrgInput = {
  metadata: CreateOrgMetadataInput;
  name: Scalars["String"]["input"];
  /** Parent Org ID */
  parentOrgId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateOrgMetadataInput = {
  accountManagerEmail: Scalars["String"]["input"];
  accountManagerFirstName: Scalars["String"]["input"];
  accountManagerLastName: Scalars["String"]["input"];
  accountManagerPhone?: InputMaybe<Scalars["String"]["input"]>;
  basicDealId: Scalars["ID"]["input"];
  basicHoldingOrgId?: InputMaybe<Scalars["ID"]["input"]>;
  basicServicingOrgEmail: Scalars["String"]["input"];
  basicServicingOrgId: Scalars["ID"]["input"];
};

export type CreateShareTokenInput = {
  resourceId: Scalars["ID"]["input"];
  resourceType: ShareResourceType;
};

export type DeclareTrackChannelInput = {
  /** Channel-specific identifier (e.g. handle or page id) */
  id: Scalars["String"]["input"];
  /** Channel the track is used on */
  type: ChannelPlatform;
  /** Link to the published usage on the channel */
  usageLinks: Array<Scalars["String"]["input"]>;
};

export type DeclareTracksInput = {
  /** Brand or campaign name */
  businessBrand: Scalars["String"]["input"];
  /** Channels the track is used on */
  channels: Array<DeclareTrackChannelInput>;
  /** Date the usage goes live */
  goLiveDate: Scalars["DateTime"]["input"];
  /** Project description */
  projectDescription: Scalars["String"]["input"];
  /** Project or product name */
  projectName: Scalars["String"]["input"];
  /** Regions the track is used in */
  regions: Array<Scalars["String"]["input"]>;
  /** Ids of the tracks being declared */
  trackIds: Array<Scalars["ID"]["input"]>;
};

export { DefaultViewInDraftMode };

export { DownloadType };

export { DownloadsScope };

export { ImportBatchStatus };

export { ImportDataStatus };

export { ImportFormat };

export { IngestionJobStatus };

export type LabAppAccessInput = {
  /** Access Label */
  label: Scalars["String"]["input"];
  /** Access Value */
  value: Scalars["String"]["input"];
};

export { LabAppEnvironment };

export type LabAppInput = {
  /** App Access */
  access: Array<LabAppAccessInput>;
  /** Allow Fullscreen Mode in App UI */
  allowFullscreen?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  /** Datastore Tables */
  datastoreTables?: InputMaybe<Array<LabDatastoreTableInput>>;
  /** Default View in Draft Mode */
  defaultViewInDraftMode?: InputMaybe<DefaultViewInDraftMode>;
  /** App description */
  description: Scalars["String"]["input"];
  /** Display Order in Apps Overview */
  displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
  /** Hide Bottom Bar in App UI */
  hideBottomBar?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** App Hosting URL */
  hostingUrl: Scalars["String"]["input"];
  /** App Icon */
  icon?: InputMaybe<Scalars["String"]["input"]>;
  /** App ID */
  id: Scalars["String"]["input"];
  /** App label */
  label: Scalars["String"]["input"];
  /** Labs Version */
  labsVersion: LabsVersion;
  /** Legal documents the user must agree to */
  legalDocuments?: InputMaybe<Array<LabAppLegalDocumentInput>>;
  /** App Local Development URL */
  localDevelopmentUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Modules */
  modules: LabAppModulesInput;
  /** App Parameters */
  parameters: Array<LabAppParameterInput>;
  /** Rate Limits */
  rateLimits?: InputMaybe<RateLimitsInput>;
  /** App Repository Link */
  repositoryLink?: InputMaybe<Scalars["String"]["input"]>;
  /** Roles assigned to users / orgs (full replace when provided) */
  roles?: InputMaybe<Array<LabAppRoleInput>>;
  /** App Secrets */
  secrets: Array<LabAppParameterInput>;
  /** Status */
  status: LabAppStatus;
};

export type LabAppLegalDocumentInput = {
  /** Key of a legal document the user must agree to */
  key: Scalars["String"]["input"];
};

export type LabAppModulesInput = {
  /** Datastore Module Enabled */
  dataStore: Scalars["Boolean"]["input"];
  /** Gemini Module Enabled */
  gemini: Scalars["Boolean"]["input"];
  /** Gemini model the app should use (falls back to the service default when unset) */
  geminiModel?: InputMaybe<Scalars["String"]["input"]>;
  /** Heap analytics tracking module enabled for this Lab app (the host additionally gates the effective value by the org's analytics settings) */
  heapTracking?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Music Search Module Enabled */
  musicSearch: Scalars["Boolean"]["input"];
  /** Org Member Search module enabled: the Lab app may list the members of the current user's org via the ORG_MEMBERS host command */
  orgMembers?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LabAppParameterInput = {
  /** Parameter Key */
  key: Scalars["String"]["input"];
  /** Parameter Value */
  value: Scalars["String"]["input"];
};

export type LabAppRoleInput = {
  /** Members assigned to this role */
  members: Array<LabAppRoleMemberInput>;
  /** Role identifier (lowercase letters and hyphens only) */
  roleId: Scalars["String"]["input"];
};

export type LabAppRoleMemberInput = {
  /** Display label resolved from member identifier */
  label: Scalars["String"]["input"];
  /** Member identifier prefixed with USER: or ORG: */
  value: Scalars["String"]["input"];
};

export { LabAppStatus };

export type LabCategoryInput = {
  /** Category ID (optional for new categories) */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Category Name */
  name: Scalars["String"]["input"];
  /** Sort Order */
  sortOrder: Scalars["Int"]["input"];
};

export type LabDatastoreAdminCreateInput = {
  /** Data as JSON */
  data: Scalars["JSON"]["input"];
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Scope of the record */
  scope: LabDatastoreScope;
  /** Table name */
  tableName: Scalars["String"]["input"];
  /** User ID (required for user-scoped records) */
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

export type LabDatastoreAdminDeleteInput = {
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Record IDs */
  ids: Array<Scalars["String"]["input"]>;
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Table name */
  tableName: Scalars["String"]["input"];
};

export type LabDatastoreAdminQueryInput = {
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Maximum results */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Pagination offset */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Table name in the datastore */
  tableName: Scalars["String"]["input"];
};

export type LabDatastoreAdminUpdateInput = {
  /** Updated data as JSON */
  data: Scalars["JSON"]["input"];
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Record ID */
  id: Scalars["String"]["input"];
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Table name */
  tableName: Scalars["String"]["input"];
};

export type LabDatastoreFieldDefinitionInput = {
  /** Case Insensitive Search */
  caseInsensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Field Name */
  name: Scalars["String"]["input"];
  /** Is Field Required */
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Is Field Searchable */
  searchable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Field Type */
  type: LabDatastoreFieldType;
};

export { LabDatastoreFieldType };

export { LabDatastoreScope };

export type LabDatastoreTableInput = {
  /** Table Field Definitions */
  fields?: InputMaybe<Array<LabDatastoreFieldDefinitionInput>>;
  /** Replace data on merge to production */
  replaceDataOnMerge?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Table Scope */
  scope: LabDatastoreScope;
  /** Table Name */
  tableName: Scalars["String"]["input"];
};

export type LabsCommandDatastoreFilterInput = {
  /** Field name to filter on */
  field: Scalars["String"]["input"];
  /** Value to match */
  value: Scalars["String"]["input"];
};

export type LabsCommandDatastoreInput = {
  /** Datastore sub-command (save, load, search, delete) */
  action: Scalars["String"]["input"];
  /** JSON data to store (for save action) */
  data?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Search filters (for search action) */
  filters?: InputMaybe<Array<LabsCommandDatastoreFilterInput>>;
  /** Record ID (required for load/delete, optional for save) */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Maximum results (for search action) */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Pagination offset (for search action) */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Table name in the datastore */
  tableName: Scalars["String"]["input"];
};

export type LabsCommandGeminiInput = {
  /** Maximum output tokens */
  maxOutputTokens?: InputMaybe<Scalars["Int"]["input"]>;
  /** Model to use */
  model?: InputMaybe<Scalars["String"]["input"]>;
  /** Prompt to send to Gemini */
  prompt: Scalars["String"]["input"];
  /** System instruction */
  systemInstruction?: InputMaybe<Scalars["String"]["input"]>;
  /** Temperature for response generation */
  temperature?: InputMaybe<Scalars["Float"]["input"]>;
};

export type LabsCommandInput = {
  /** App ID to execute command against */
  appId: Scalars["String"]["input"];
  /** Command to execute */
  command: Scalars["String"]["input"];
  /** Datastore-specific input */
  datastore?: InputMaybe<LabsCommandDatastoreInput>;
  /** Environment - routes datastore operations to the specified environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Gemini-specific input */
  gemini?: InputMaybe<LabsCommandGeminiInput>;
  /** Log Error-specific input */
  logError?: InputMaybe<LabsCommandLogErrorInput>;
  /** Music Search-specific input */
  musicSearch?: InputMaybe<LabsCommandMusicSearchInput>;
  /** Org Members-specific input */
  orgMembers?: InputMaybe<LabsCommandOrgMembersInput>;
  /** User Action Log-specific input */
  userActionLog?: InputMaybe<LabsCommandUserActionLogInput>;
};

export type LabsCommandLogErrorInput = {
  /** Error message */
  message: Scalars["String"]["input"];
  /** Error stack trace */
  stack?: InputMaybe<Scalars["String"]["input"]>;
};

export type LabsCommandMusicSearchInput = {
  /** Number of results to return */
  limit: Scalars["Int"]["input"];
  /** Number of results to skip for pagination */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Search query */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Search type (e.g., SMART_SEARCH, EXACT_MATCH) */
  searchType?: InputMaybe<SearchType>;
};

export type LabsCommandOrgMembersInput = {
  /** Number of members to return (max 100) */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Number of members to skip for pagination */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Filters members by name or email */
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type LabsCommandUserActionLogInput = {
  /** Action identifier (e.g. INIT, BUTTON_CLICK, etc.) */
  action: Scalars["String"]["input"];
  /** Optional arbitrary data */
  data?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Path / route within the lab app */
  path?: InputMaybe<Scalars["String"]["input"]>;
  /** Reference identifier */
  reference: Scalars["String"]["input"];
  /** Reference key */
  referenceKey: Scalars["String"]["input"];
};

export { LabsVersion };

export type LegalConfirmationInput = {
  label: Scalars["String"]["input"];
};

export { LibraryLicenseChannelType };

export type LibraryLicenseSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<LibraryLicenseSortKey>;
};

export { LibraryLicenseSortKey };

export { LikeItemsType };

export type MsaDocumentCreateInput = {
  key: Scalars["String"]["input"];
  selection: MsaDocumentSelection;
};

export { MsaDocumentSelection };

export type MsaLogEntryInput = {
  action: Action;
  key: Scalars["String"]["input"];
};

export { MsaMonetizationPreference };

export type MsaProfileCreateInput = {
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  source: MsaProfileSourceInput;
};

export type MsaProfileDocumentSelectionUpdateInput = {
  key: Scalars["String"]["input"];
  selection: MsaDocumentSelection;
};

export type MsaProfileMonetizationPrefUpdateInput = {
  key: Scalars["String"]["input"];
  preference: MsaMonetizationPreference;
};

export type MsaProfileSourceInput = {
  id: Scalars["Int"]["input"];
  type: MsaSourceType;
};

export { MsaProfileStatus };

export type MsaProfileStatusUpdateInput = {
  key: Scalars["String"]["input"];
  status: MsaProfileStatus;
};

export { MsaSourceType };

export type MsaSurveyLogEntryInput = {
  key: Scalars["String"]["input"];
  selectionBitMask: Scalars["Int"]["input"];
  textResponse?: InputMaybe<Scalars["String"]["input"]>;
};

export { NotificationStatus };

export { NotificationType };

export { OrgLoginMethods };

export { OrgUserInviteBatchStatus };

export type OrgUserInviteInput = {
  /** Invite email */
  emails: Array<Scalars["String"]["input"]>;
  /** Invite permissions */
  permissions: Array<Scalars["String"]["input"]>;
  /** Invite roles */
  roles: Array<Scalars["String"]["input"]>;
};

export { OrgUserInviteLookupStatus };

export type OrgUserInviteSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<OrgUserInviteSortKey>;
};

export { OrgUserInviteSortKey };

export { OrgUserInviteStatus };

export { OrgUserStatus };

export type OrgsSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<OrgsSortKey>;
};

export { OrgsSortKey };

export { PayoutBatchStatus };

export { PayoutBatchTask };

export { PayoutCommentAction };

export type PayoutEligibleSort = {
  direction: SortDirection;
  key?: InputMaybe<PayoutEligibleSortKey>;
};

export { PayoutEligibleSortKey };

export { PayoutIssueKind };

export { PayoutItemSource };

export { PayoutItemStatus };

export { PayoutStatus };

export { PayoutTrolleyStatus };

export type RateLimitConfigInput = {
  /** App-wide rate limit */
  app?: InputMaybe<RateLimitSettingsInput>;
  /** Per-user rate limit */
  user?: InputMaybe<RateLimitSettingsInput>;
};

export type RateLimitSettingsInput = {
  /** Maximum number of requests */
  maxRequests?: InputMaybe<Scalars["Int"]["input"]>;
  /** Enable rate limiting */
  useRateLimiting?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Time window in seconds */
  windowSeconds?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RateLimitsInput = {
  /** App-wide calls */
  appWide?: InputMaybe<RateLimitConfigInput>;
  /** Datastore calls */
  dataStore?: InputMaybe<RateLimitConfigInput>;
  /** Gemini AI calls */
  gemini?: InputMaybe<RateLimitConfigInput>;
  /** Music Search calls */
  musicSearch?: InputMaybe<RateLimitConfigInput>;
};

export type RecordLegalAgreementInput = {
  /** Labels of every confirmation the user ticked. Must match the document's confirmation labels exactly. */
  acceptedConfirmations: Array<Scalars["String"]["input"]>;
  /** Base64-encoded pipe-joined client fingerprint material (userAgent, screen, timezone, language, cpuClass). Combined with the server-observed client IP to produce an opaque proof-of-client token stored alongside the agreement. */
  clientInfo: Scalars["String"]["input"];
  /** ID of the document version the user is accepting */
  documentId: Scalars["ID"]["input"];
};

export { ReportColumnType };

export { ReportParameterType };

export type ReportParameterValueInput = {
  name: Scalars["String"]["input"];
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type ResourceSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<ResourceSortKey>;
};

export { ResourceSortKey };

export type SavedMediaFileInput = {
  id: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  size: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
  uploadComplete: Scalars["Boolean"]["input"];
};

export type SearchFilterInput = {
  name: SearchFilterName;
  values: Array<Scalars["String"]["input"]>;
};

export { SearchFilterName };

export { SearchSortDirection };

export { SearchSortKey };

export { SearchType };

export { SessionEvent };

export { ShareResourceType };

export { SignatoryStatus };

export type SignatureDocumentCreateInput = {
  declineRedirectUrl?: InputMaybe<Scalars["String"]["input"]>;
  expiresInSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  hideWelcomeDialog?: InputMaybe<Scalars["Boolean"]["input"]>;
  signatories: Array<SignatureDocumentSignatoryInput>;
  successRedirectUrl?: InputMaybe<Scalars["String"]["input"]>;
  templateKey: Scalars["String"]["input"];
  userConfirmData?: InputMaybe<Scalars["Boolean"]["input"]>;
  webhookUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type SignatureDocumentDeclineInput = {
  declineReasons: Array<Scalars["String"]["input"]>;
  documentId: Scalars["String"]["input"];
  sessionId: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
};

export type SignatureDocumentDeclineReasonInput = {
  reasonKey: Scalars["String"]["input"];
  reasonText: Scalars["String"]["input"];
};

export type SignatureDocumentQueryInput = {
  clientInfo: Scalars["String"]["input"];
  documentId: Scalars["String"]["input"];
  mobileSigningInProgress?: InputMaybe<Scalars["Boolean"]["input"]>;
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
  signatoryId: Scalars["String"]["input"];
};

export type SignatureDocumentSignInput = {
  clientInfo: Scalars["String"]["input"];
  documentId: Scalars["String"]["input"];
  sessionId: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
  signatureBase64: Scalars["String"]["input"];
};

export type SignatureDocumentSignatoryInput = {
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
};

export type SignatureDocumentSignatoryUpdateInput = {
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  documentId: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
};

export { SignatureDocumentStatus };

export type SignatureDocumentTemplateCreateInput = {
  declineReasons: Array<SignatureDocumentDeclineReasonInput>;
  description: Scalars["String"]["input"];
  internalNotificationEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  pdfUrl: Scalars["String"]["input"];
  templateKey: Scalars["String"]["input"];
};

export { SortDirection };

export type StatementCreateInput = {
  /** Statement details */
  details: Array<StatementDetailCreateInput>;
  /** Statement ID */
  id: Scalars["String"]["input"];
  /** Statement additional information */
  information?: InputMaybe<Scalars["String"]["input"]>;
  /** Statement issued date */
  issued: Scalars["DateTime"]["input"];
  /** Statement net revenue */
  netRevenue: Scalars["Float"]["input"];
  /** Organization ID */
  orgId: Scalars["String"]["input"];
  /** Statement payment */
  payment: StatementPaymentCreateInput;
  /** Statement period */
  period: Array<Scalars["DateTime"]["input"]>;
  /** Statement report */
  report: StatementReportCreateInput;
  /** Statement service */
  service: Scalars["String"]["input"];
  /** Statement source */
  source: StatementSourceCreateInput;
};

export type StatementDetailCreateInput = {
  /** Detail label */
  label: Scalars["String"]["input"];
  /** Detail value */
  value: Scalars["String"]["input"];
};

export type StatementImportCreateBatchInput = {
  /** S3 key of the uploaded file */
  fileKey: Scalars["String"]["input"];
  /** Original file name */
  fileName: Scalars["String"]["input"];
  /** Import format to process the file with */
  format: ImportFormat;
};

export type StatementImportDataSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<StatementImportDataSortKey>;
};

export { StatementImportDataSortKey };

export type StatementPaymentCreateInput = {
  /** Payment date */
  date?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Payment status; Pending is derived from payouts and rejected here */
  status: StatementPaymentStatus;
};

export { StatementPaymentStatus };

export type StatementReportCreateInput = {
  /** Report file object */
  file: StatementReportFileCreateInput;
  /** Report file source URL */
  sourceUrl: Scalars["String"]["input"];
};

export type StatementReportFileCreateInput = {
  /** File extension */
  extension: Scalars["String"]["input"];
};

export type StatementSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<StatementSortKey>;
};

export { StatementSortKey };

export type StatementSourceCreateInput = {
  /** Source app ID */
  id: Scalars["String"]["input"];
  /** Source app type */
  type: Scalars["String"]["input"];
};

export type StatementUpdateInput = {
  /** Statement details */
  details?: InputMaybe<Array<InputMaybe<StatementDetailCreateInput>>>;
  /** Statement ID */
  id: Scalars["String"]["input"];
  /** Statement additional information */
  information?: InputMaybe<Scalars["String"]["input"]>;
  /** Statement issued date */
  issued?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Statement net revenue */
  netRevenue?: InputMaybe<Scalars["Float"]["input"]>;
  /** Organization ID */
  orgId: Scalars["String"]["input"];
  /** Statement payment */
  payment?: InputMaybe<StatementPaymentCreateInput>;
  /** Statement period */
  period?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  /** Statement service */
  service?: InputMaybe<Scalars["String"]["input"]>;
  /** Statement source */
  source?: InputMaybe<StatementSourceCreateInput>;
};

export { StemOutputFormat };

export { StemStatus };

export { TrackSortDirection };

export { TrackSortKey };

export { TrackType };

export type UpdateClientInput = {
  /** Client contact */
  contact: Scalars["String"]["input"];
  /** Client email */
  email: Scalars["String"]["input"];
  /** Client ID */
  id: Scalars["ID"]["input"];
  /** Client name */
  name: Scalars["String"]["input"];
};

export type UpdateIngestionJobInput = {
  csvOriginalFilename?: InputMaybe<Scalars["String"]["input"]>;
  dromoImportId?: InputMaybe<Scalars["String"]["input"]>;
  dromoImportIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  dromoSessionId?: InputMaybe<Scalars["String"]["input"]>;
  jobId: Scalars["ID"]["input"];
  jobName?: InputMaybe<Scalars["String"]["input"]>;
  licensorDpid?: InputMaybe<Scalars["String"]["input"]>;
  mappingSnapshot?: InputMaybe<Scalars["JSON"]["input"]>;
  mediaFiles?: InputMaybe<Array<SavedMediaFileInput>>;
  metadataRowCount?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<IngestionJobStatus>;
};

export type UpdateLegalDocumentInput = {
  confirmations?: InputMaybe<Array<LegalConfirmationInput>>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  effectiveDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  requiresReagreement?: InputMaybe<Scalars["Boolean"]["input"]>;
  requiresScrollToAccept?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateLegalDocumentVariantInput = {
  name: Scalars["String"]["input"];
  /** Full set of orgs for the version */
  orgIds: Array<Scalars["ID"]["input"]>;
};

export type UpdateOrgDetailsInput = {
  metadata: UpdateOrgDetailsMetadataInput;
  /** Org name */
  name: Scalars["String"]["input"];
  /** Parent Org ID */
  parentOrgId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UpdateOrgDetailsMetadataInput = {
  accountManagerEmail: Scalars["String"]["input"];
  accountManagerFirstName: Scalars["String"]["input"];
  accountManagerLastName: Scalars["String"]["input"];
  accountManagerPhone?: InputMaybe<Scalars["String"]["input"]>;
  /** Analytics Heap enabled */
  analyticsHeapEnabled: Scalars["Boolean"]["input"];
  basicDealId: Scalars["ID"]["input"];
  basicHoldingOrgId?: InputMaybe<Scalars["ID"]["input"]>;
  basicServicingOrgEmail: Scalars["String"]["input"];
  basicServicingOrgId: Scalars["ID"]["input"];
  /** Org HubSpot IDs. Used to link the org to it's counterpart in the HubSpot system. */
  hubSpotIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Org billing email address */
  payoutsBillingEmail?: InputMaybe<Scalars["String"]["input"]>;
  /** Minimum payout in USD cents, at least the platform minimum. Null resets it to the default; omitted keeps it. */
  payoutsMinimumPayoutCents?: InputMaybe<Scalars["Int"]["input"]>;
  /** Org Trolley reference ID. Custom identifier that can be assigned to an entity when creating it within Trolley's system. By default, it is the same as the organization ID. */
  payoutsTrolleyRefId: Scalars["ID"]["input"];
  priceEstimationCurrency?: InputMaybe<Scalars["Currency"]["input"]>;
  priceEstimationInstagramFollowers?: InputMaybe<Scalars["Int"]["input"]>;
  priceEstimationMarketCap?: InputMaybe<Scalars["Int"]["input"]>;
  priceEstimationMarketSymbol?: InputMaybe<Scalars["String"]["input"]>;
  priceEstimationNumberOfEmployees?: InputMaybe<Scalars["Int"]["input"]>;
  priceEstimationPublicCompany?: InputMaybe<Scalars["Boolean"]["input"]>;
  priceEstimationTikTokFollowers?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateOrgModulesInput = {
  /** List of modules to be enabled for the organization */
  modules: Array<UpdateOrgModulesModuleInput>;
};

export type UpdateOrgModulesModuleInput = {
  name: Scalars["String"]["input"];
  value: Scalars["Boolean"]["input"];
};

export { UrlType };

export { UserActionLogSource };

export { UserPlaylistsSortDirection };

export { UserPlaylistsSortKey };

export { UserSubscriptionAddOnPricing };

export { UserSubscriptionProvider };

export type ValidateFilesInput = {
  catalogUploadId: Scalars["String"]["input"];
  filenames: Array<Scalars["String"]["input"]>;
};

export type AuthRedirectProbeQueryVariables = Exact<{ [key: string]: never }>;

export type AuthRedirectProbeQuery = { __typename: "Query" };

export type UserLayoutQueryVariables = Exact<{ [key: string]: never }>;

export type UserLayoutQuery = {
  __typename?: "Query";
  user: {
    __typename?: "CurrentUser";
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    picture?: string | null;
    orgId: string;
    permissions: Array<string>;
    labApps?: Array<string> | null;
    inOrgs: Array<{
      __typename?: "UserOrg";
      id: string;
      parentOrgId?: string | null;
      name: string;
      workspace?: string | null;
    }>;
    isImInfo?: {
      __typename?: "IsImInfo";
      isIm: boolean;
      title: string;
      body: string;
      disclaimer: string;
      confirmLabel: string;
    } | null;
    subscription?: {
      __typename?: "UserSubscription";
      provider: UserSubscriptionProvider;
      name?: string | null;
      isActive: boolean;
      manageUrl?: string | null;
    } | null;
  };
  org: {
    __typename?: "Org";
    id: string;
    parentOrgId?: string | null;
    name: string;
    workspace?: string | null;
    loginMethods: Array<OrgLoginMethods>;
    metadata?: {
      __typename?: "OrgMetadata";
      analytics?: {
        __typename?: "OrgMetadataAnalytics";
        heap?: {
          __typename?: "OrgMetadataAnalyticsHeap";
          enabled: boolean;
        } | null;
      } | null;
      assets?: {
        __typename?: "OrgMetadataAssets";
        logo?: string | null;
        background?: string | null;
      } | null;
    } | null;
  };
};

export const AuthRedirectProbeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuthRedirectProbe" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuthRedirectProbeQuery,
  AuthRedirectProbeQueryVariables
>;
export const UserLayoutDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UserLayout" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "picture" } },
                { kind: "Field", name: { kind: "Name", value: "orgId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inOrgs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parentOrgId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "workspace" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "permissions" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isImInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "isIm" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "body" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "disclaimer" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "confirmLabel" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "labApps" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isActive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "manageUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "org" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentOrgId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "workspace" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "loginMethods" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "analytics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "heap" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "enabled" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "logo" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "background" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserLayoutQuery, UserLayoutQueryVariables>;
